export default {
    listing: [
        {
            source: 'estimate',
            groups: [
                [
                    {
                        name: 'remainingInvoicedAmount',
                        illustration: 'money-waiting',
                        type: 'item',
                        suffix: 'common.labels.taxes_included',
                    },
                ],
                [
                    {
                        name: 'sumTotalAmountTaxesFree',
                        type: 'item',
                        suffix: 'common.labels.taxes_excluded',
                    },
                    {
                        name: 'sumTotalAmount',
                        type: 'item',
                        suffix: 'common.labels.taxes_included',
                        hideTitle: true,
                    },
                ],
                [
                    {
                        name: 'avgTotalAmountTaxesFree',
                        type: 'item',
                        suffix: 'common.labels.taxes_excluded',
                    },
                    {
                        name: 'avgTotalAmount',
                        type: 'item',
                        suffix: 'common.labels.taxes_included',
                        hideTitle: true,
                    },
                ],
                [
                    {
                        name: 'sumTaxesAmountSum',
                        type: 'item',
                        suffix: 'common.labels.taxes_included',
                    },
                ],
                [
                    {
                        name: 'sumMargin',
                        type: 'item',
                        suffix: 'common.labels.taxes_excluded',
                    },
                    {
                        name: 'avgMargin',
                        type: 'item',
                        suffix: 'common.labels.taxes_excluded',
                    },
                    {
                        name: 'avgMarkupRate',
                        type: 'item',
                    },
                    {
                        name: 'avgMarginRate',
                        type: 'item',
                    },
                ],
            ],
        },
        {
            source: 'invoice',
            groups: [
                [
                    {
                        name: 'sumPayment',
                        type: 'item',
                        illustration: 'piggybank',
                        suffix: 'common.labels.taxes_included',
                    },
                    {
                        name: 'sumDueAmount',
                        type: 'item',
                        illustration: 'money-waiting',
                    },
                ],
                [
                    {
                        name: 'sumTotalAmountTaxesFree',
                        type: 'item',
                        suffix: 'common.labels.taxes_excluded',
                    },
                    {
                        name: 'sumTotalAmount',
                        type: 'item',
                        suffix: 'common.labels.taxes_included',
                        hideTitle: true,
                    },
                ],
                [
                    {
                        name: 'avgTotalAmountTaxesFree',
                        type: 'item',
                        suffix: 'common.labels.taxes_excluded',
                    },
                    {
                        name: 'avgTotalAmount',
                        type: 'item',
                        suffix: 'common.labels.taxes_included',
                        hideTitle: true,
                    },
                ],
                [
                    {
                        name: 'sumTaxesAmountSum',
                        type: 'item',
                        suffix: 'common.labels.taxes_included',
                    },
                ],
                [
                    {
                        name: 'sumMargin',
                        type: 'item',
                        suffix: 'common.labels.taxes_excluded',
                    },
                    {
                        name: 'avgMargin',
                        type: 'item',
                        suffix: 'common.labels.taxes_excluded',
                    },
                    {
                        name: 'avgMarkupRate',
                        type: 'item',
                    },
                    {
                        name: 'avgMarginRate',
                        type: 'item',
                    },
                ],
            ],
        },
        {
            source: 'order',
            groups: [
                [
                    {
                        name: 'remainingInvoicedAmount',
                        illustration: 'money-waiting',
                        type: 'item',
                        suffix: 'common.labels.taxes_included',
                    },
                ],
                [
                    {
                        name: 'sumTotalAmountTaxesFree',
                        type: 'item',
                        suffix: 'common.labels.taxes_excluded',
                    },
                    {
                        name: 'sumTotalAmount',
                        type: 'item',
                        suffix: 'common.labels.taxes_included',
                        hideTitle: true,
                    },
                ],
                [
                    {
                        name: 'avgTotalAmountTaxesFree',
                        type: 'item',
                        suffix: 'common.labels.taxes_excluded',
                    },
                    {
                        name: 'avgTotalAmount',
                        type: 'item',
                        suffix: 'common.labels.taxes_included',
                        hideTitle: true,
                    },
                ],
                [
                    {
                        name: 'sumTaxesAmountSum',
                        type: 'item',
                        suffix: 'common.labels.taxes_included',
                    },
                ],
            ],
        },
        {
            source: 'delivery',
            groups: [
                [
                    {
                        name: 'sumTotalAmountTaxesFree',
                        type: 'item',
                        suffix: 'common.labels.taxes_excluded',
                    },
                    {
                        name: 'sumTotalAmount',
                        type: 'item',
                        suffix: 'common.labels.taxes_included',
                        hideTitle: true,
                    },
                ],
                [
                    {
                        name: 'avgTotalAmountTaxesFree',
                        type: 'item',
                        suffix: 'common.labels.taxes_excluded',
                    },
                    {
                        name: 'avgTotalAmount',
                        type: 'item',
                        suffix: 'common.labels.taxes_included',
                        hideTitle: true,
                    },
                ],
                [
                    {
                        name: 'sumTaxesAmountSum',
                        type: 'item',
                        suffix: 'common.labels.taxes_included',
                    },
                ],
            ],
        },
        {
            source: 'creditnote',
            groups: [
                [
                    {
                        name: 'sumTotalAmountTaxesFree',
                        type: 'item',
                        suffix: 'common.labels.taxes_excluded',
                    },
                    {
                        name: 'sumTotalAmount',
                        type: 'item',
                        suffix: 'common.labels.taxes_included',
                        hideTitle: true,
                    },
                ],
                [
                    {
                        name: 'avgTotalAmountTaxesFree',
                        type: 'item',
                        suffix: 'common.labels.taxes_excluded',
                    },
                    {
                        name: 'avgTotalAmount',
                        type: 'item',
                        hideTitle: true,
                        suffix: 'common.labels.taxes_included',
                    },
                ],
                [
                    {
                        name: 'sumTaxesAmountSum',
                        type: 'item',
                        suffix: 'common.labels.taxes_included',
                    },
                ],
            ],
        },
        {
            source: 'proforma',
            groups: [
                [
                    {
                        name: 'sumTotalAmountTaxesFree',
                        type: 'item',
                        suffix: 'common.labels.taxes_excluded',
                    },
                    {
                        name: 'sumTotalAmount',
                        type: 'item',
                        suffix: 'common.labels.taxes_included',
                        hideTitle: true,
                    },
                ],
                [
                    {
                        name: 'avgTotalAmountTaxesFree',
                        type: 'item',
                        suffix: 'common.labels.taxes_excluded',
                    },
                    {
                        name: 'avgTotalAmount',
                        type: 'item',
                        hideTitle: true,
                        suffix: 'common.labels.taxes_included',
                    },
                ],
                [
                    {
                        name: 'sumTaxesAmountSum',
                        type: 'item',
                        suffix: 'common.labels.taxes_included',
                    },
                ],
            ],
        },
        {
            source: 'purInvoice',
            groups: [
                [
                    {
                        name: 'sumTotalAmountTaxesFree',
                        type: 'item',
                        suffix: 'common.labels.taxes_excluded',
                    },
                    {
                        name: 'sumTotalAmount',
                        type: 'item',
                        suffix: 'common.labels.taxes_included',
                        hideTitle: true,
                    },
                    {
                        name: 'avgTotalAmountTaxesFree',
                        type: 'item',
                        suffix: 'common.labels.taxes_excluded',
                    },
                ],
                [
                    {
                        name: 'sumTaxesAmountSum',
                        type: 'item',
                        suffix: 'common.labels.taxes_included',
                    },
                ],
                [
                    {
                        name: 'sumDueAmount',
                        type: 'item',
                        suffix: 'common.labels.taxes_included',
                        illustration: 'money-waiting',
                    },
                ],
            ],
        },
        {
            source: 'purCreditNote',
            groups: [
                [
                    {
                        name: 'sumTotalAmountTaxesFree',
                        type: 'item',
                        suffix: 'common.labels.taxes_excluded',
                    },
                    {
                        name: 'sumTotalAmount',
                        type: 'item',
                        suffix: 'common.labels.taxes_included',
                        hideTitle: true,
                    },
                    {
                        name: 'avgTotalAmountTaxesFree',
                        type: 'item',
                        suffix: 'common.labels.taxes_excluded',
                    },
                ],
                [
                    {
                        name: 'sumTaxesAmountSum',
                        type: 'item',
                        suffix: 'common.labels.taxes_included',
                    },
                ],
            ],
        },
        {
            source: 'purOrder',
            groups: [
                [
                    {
                        name: 'sumTotalAmountTaxesFree',
                        type: 'item',
                        suffix: 'common.labels.taxes_excluded',
                    },
                    {
                        name: 'sumTotalAmount',
                        type: 'item',
                        suffix: 'common.labels.taxes_included',
                        hideTitle: true,
                    },
                    {
                        name: 'avgTotalAmountTaxesFree',
                        type: 'item',
                        suffix: 'common.labels.taxes_excluded',
                    },
                ],
                [
                    {
                        name: 'sumTaxesAmountSum',
                        type: 'item',
                        suffix: 'common.labels.taxes_included',
                    },
                ],
            ],
        },
        {
            source: 'purDelivery',
            groups: [
                [
                    {
                        name: 'sumTotalAmountTaxesFree',
                        type: 'item',
                        suffix: 'common.labels.taxes_excluded',
                    },
                    {
                        name: 'sumTotalAmount',
                        type: 'item',
                        suffix: 'common.labels.taxes_included',
                        hideTitle: true,
                    },
                    {
                        name: 'avgTotalAmountTaxesFree',
                        type: 'item',
                        suffix: 'common.labels.taxes_excluded',
                    },
                ],
                [
                    {
                        name: 'sumTaxesAmountSum',
                        type: 'item',
                        suffix: 'common.labels.taxes_included',
                    },
                ],
            ],
        },
        {
            source: 'opportunity',
            groups: [
                [
                    {
                        name: 'weighted_potential',
                        type: 'item',
                        illustration: 'target',
                    },
                    {
                        name: 'total_potential',
                        type: 'item',
                    },
                ],
                [
                    {
                        name: 'avg_proba',
                        type: 'item',
                        illustration: 'probability',
                    },
                ],
            ],
        },
        {
            source: 'agedbalance',
            groups: [
                [
                    {
                        name: 'expected_90more',
                        type: 'item',
                    },
                    {
                        name: 'expected_60',
                        type: 'item',
                    },
                    {
                        name: 'expected_30',
                        type: 'item',
                    },
                    {
                        name: 'expected_0',
                        type: 'item',
                    },
                ],
                [
                    {
                        name: 'late_30',
                        type: 'item',
                    },
                    {
                        name: 'late_60',
                        type: 'item',
                    },
                    {
                        name: 'late_90',
                        type: 'item',
                    },
                    {
                        name: 'late_90more',
                        type: 'item',
                    },
                ],
            ],
        },
        {
            source: 'accountingEntry',
            groups: [
                [
                    {
                        name: 'credit_debit.debit',
                        type: 'item',
                        illustration: 'expenses',
                    },
                ],
                [
                    {
                        name: 'credit_debit.credit',
                        type: 'item',
                        illustration: 'profits',
                    },
                ],
            ],
        },
        {
            source: 'payments',
            groups: [
                [
                    {
                        name: 'total_credit',
                        type: 'item',
                    },
                    {
                        name: 'total_credit_remaining',
                        type: 'item',
                        illustration: 'waiting-credit',
                    },
                ],
                [
                    {
                        name: 'total_debit',
                        type: 'item',
                    },
                    {
                        name: 'total_debit_remaining',
                        type: 'item',
                        illustration: 'waiting-debit',
                    },
                ],
                [
                    {
                        name: 'total_balance',
                        type: 'item',
                        illustration: 'scale',
                    },
                ],
            ],
        },
        {
            source: 'deadlines',
            groups: [
                [
                    {
                        name: 'sumDeadlines',
                        type: 'item',
                    },
                    {
                        name: 'sumDue',
                        illustration: 'expenses',
                        type: 'item',
                    },
                    {
                        name: 'sumLate',
                        illustration: 'money-waiting',
                        type: 'item',
                    },
                ],
            ],
        },
        {
            source: 'salesbythird',
            groups: [
                [
                    {
                        name: 'turnover',
                        type: 'item',
                        suffix: 'common.labels.taxes_excluded',
                    },
                    {
                        name: 'arpu',
                        type: 'item',
                        suffix: 'common.labels.taxes_excluded',
                    },
                ],
                [
                    {
                        name: 'qtSold',
                        type: 'item',
                    },
                ],
                [
                    {
                        name: 'invoicesCount',
                        type: 'item',
                    },
                ],
                [
                    {
                        name: 'creditnotesCount',
                        type: 'item',
                    },
                ],
            ],
        },
        {
            source: 'activity',
            groups: [
                [
                    {
                        name: 'by_event.total',
                        type: 'item',
                    },
                ],
                [
                    {
                        name: 'by_event.email',
                        type: 'item',
                        illustration: 'email',
                    },
                    {
                        name: 'by_event.phonecall',
                        type: 'item',
                        illustration: 'phonecall',
                    },
                    {
                        name: 'by_event.task',
                        type: 'item',
                        illustration: 'task',
                    },
                    {
                        name: 'by_event.event',
                        type: 'item',
                        illustration: 'event',
                    },
                ],
            ],
        },
    ],
    overview: [
        {
            source: 'estimate',
            groups: [
                [
                    {
                        name: 'globalProgressPercent',
                        type: 'progress',
                    },
                ],
                [
                    {
                        name: 'totalAmountTaxesFree',
                        illustration: 'piggybank',
                        type: 'item',
                    },
                    {
                        name: 'expenditure',
                        illustration: 'expenses',
                        type: 'item',
                    },
                ],
                [
                    {
                        name: 'margin',
                        type: 'item',
                    },
                    {
                        name: 'markUpRate',
                        type: 'item',
                    },
                    {
                        name: 'marginRate',
                        type: 'item',
                    },
                ],
            ],
        },
        {
            source: 'invoice',
            groups: [
                [
                    {
                        name: 'totalAmountTaxesFree',
                        illustration: 'piggybank',
                        type: 'item',
                    },
                    {
                        name: 'expenditure',
                        illustration: 'expenses',
                        type: 'item',
                    },
                ],
                [
                    {
                        name: 'margin',
                        type: 'item',
                    },
                    {
                        name: 'markUpRate',
                        type: 'item',
                    },
                    {
                        name: 'marginRate',
                        type: 'item',
                    },
                ],
            ],
        },
        {
            source: 'proforma',
            groups: [
                [
                    {
                        name: 'totalAmountTaxesFree',
                        illustration: 'piggybank',
                        type: 'item',
                    },
                    {
                        name: 'expenditure',
                        illustration: 'expenses',
                        type: 'item',
                    },
                ],
                [
                    {
                        name: 'margin',
                        type: 'item',
                    },
                    {
                        name: 'markUpRate',
                        type: 'item',
                    },
                    {
                        name: 'marginRate',
                        type: 'item',
                    },
                ],
            ],
        },
        {
            source: 'catalogueitem',
            groups: [
                [
                    {
                        name: 'avgSell',
                        type: 'item',
                    },
                ],
                [
                    {
                        name: 'sumSell',
                        illustration: 'piggybank',
                        type: 'item',
                    },
                ],
                [
                    {
                        name: 'sumQt',
                        type: 'item',
                    },
                    {
                        name: 'avgQtSell',
                        type: 'item',
                    },
                ],
                [
                    {
                        name: 'bestThird',
                        illustration: 'buyer',
                        type: 'item',
                    },
                    {
                        name: 'bestStaff',
                        illustration: 'sales',
                        type: 'item',
                    },
                ],
            ],
        },
    ],
};
